// assets
import { IconKey,IconShoppingCart } from '@tabler/icons';

// constant
const icons = {
    IconKey,
    IconShoppingCart
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const procurement = {


    id: 'authentication',
    title: 'Procurement',
    type: 'group',
    display_id:'D',
    icon: icons.IconShoppingCart,
    children: [
       {
            id: 'adddevice',
            title: 'Device Module',
            display_id:18,
            type: 'item',
            url: '/Admin/Add_Device',
            breadcrumbs: false
        },
        {
            id: 'devicerequest',
            title: 'Device Payment Collection',
            display_id:92,
            type: 'item',
            url: '/Admin/Device_Request',
            breadcrumbs: false
        },
        // {
        //     id: 'addvendor',
        //     title: 'Add Vendor',
        //     display_id:19,
        //     type: 'item',
        //     url: '/Admin/Add_Vendor',
        //     breadcrumbs: false
        // },
        {
            id:'vendor_list',
            title: 'Vendor List',
            display_id:89,
            type: 'item',
            url: '/Admin/Vendor_List',
            breadcrumbs: false
        },
        {
            id: 'vendor_onboarding_request',
            title: 'Vendor Onboarding Request',
            display_id:90,
            type: 'item',
            url: '/Admin/vendor_onboarding_request',
            breadcrumbs: false
        },
        {
            id: 'purchase_request',
            title: 'Purchase request',
            display_id:91,
            type: 'item',
            url: '/procurement/purchase_request',
            breadcrumbs: false
        },
        {
            id: 'create_po',
            title: 'Create Purchase Order',
            display_id:99,
            type: 'item',
            url: '/procurement/create_purchase_order',
            breadcrumbs: false
        },

        {
            id: 'create_payment_order',
            title: 'Create Payment Order',
            display_id:100,
            type: 'item',
            url: '/procurement/create_payment_order',
            breadcrumbs: false
        },

        {
            id: 'procurement_Head_PO_pending_Page',
            title: 'Purchase Order',
            display_id:95,
            type: 'item',
            url: '/Admin/procurement_Head_PO_pending_Page',
            breadcrumbs: false
        },
        {
            id: 'payment_order',
            title: 'Payment Order',
            display_id:97,
            type: 'item',
            url: '/Admin/payment_orders',
            breadcrumbs: false
        },
        {
            id: 'complete_payment',
            title: 'Complete Payment',
            display_id:98,
            type: 'item',
            url: '/Admin/complete_payment',
            breadcrumbs: false
        },
        {
            id: 'invoice',
            title: 'Invoice',
            display_id:96,
            type: 'item',
            url: '/Admin/Invoice',
            breadcrumbs: false
        },
        {
            id: 'product_ship',
            title: 'Product Shipment',
            display_id:93,
            type: 'item',
            url: '/Admin/Product_Ship',
            breadcrumbs: false
        },
        {
            id: 'delivery_note_status',
            title: 'Delivery Note Status',
            display_id:97,
            type: 'item',
            url: '/Admin/Delivery_Note_Status',
            breadcrumbs: false
        },
        {
            id: 'branding_request',
            title: 'Agent Branding request',
            display_id:108,
            type: 'item',
            url: '/procurement/brandingrequest',
            breadcrumbs: false
        },
        {
            id: 'upload_brand',
            title: 'Upload Branding',
            display_id:109,
            type: 'item',
            url: '/procurement/uploadbrand',
            breadcrumbs: false
        },
        {
            id: 'brand_dashboard',
            title: 'Branding Dashboard',
            display_id:110,
            type: 'item',
            url: '/branding/dashboard',
            breadcrumbs: false
        },
          {
            id: 'stock_dashboard',
            title: 'Stock Dashboard',
            display_id:120,
            type: 'item',
            url: '/stock/dashboard',
            breadcrumbs: false
        },


    ].filter(Boolean)

};

export default procurement;
